export default __webpack_public_path__ + "static/media/5 00_00_00-02_21_00.10aa9c9f.mp4";